import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';
import {Body} from 'shells/typography/body';

import {Setting} from '../../../core/setting';

const EMAIL_TRACKING_DISABLED_KEY = 'user_email_tracking_disabled';

type Props = {
    onError: (arg1: string) => void;
    disabled: boolean;
};

export function EmailTrackingSetting(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<string | null | undefined>(null);
    const savedTimeoutRef = React.useRef();

    return (
        <Setting settingName={EMAIL_TRACKING_DISABLED_KEY}>
            {/* @ts-expect-error */}
            {(emailTrackingDisabledSetting) => {
                if (emailTrackingDisabledSetting.setting) {
                    const disabled =
                        props.disabled ||
                        emailTrackingDisabledSetting.isLoading ||
                        emailTrackingDisabledSetting.isUpdating;

                    const trackingIsDisabled = emailTrackingDisabledSetting.setting.value === '1';

                    return (
                        <SavedSettingToast state={valueSaved ? 'complete' : 'initial'}>
                            <Checkbox
                                disabled={disabled}
                                label={
                                    <Body>
                                        Track when messages sent from Nutshell are opened or clicked
                                    </Body>
                                }
                                checked={!trackingIsDisabled}
                                hasError={Boolean(emailTrackingDisabledSetting.error)}
                                onChange={(newValue) => {
                                    // Confusing, but our setting value is "flipped". If the user
                                    // has checked this, they want to enable email tracking, so
                                    // disabled email tracking is disabled.
                                    emailTrackingDisabledSetting
                                        .updateSetting(newValue ? '0' : '1')
                                        .then((mutationResult) => {
                                            setValueSaved(
                                                mutationResult &&
                                                    mutationResult.data &&
                                                    mutationResult.data.updateSetting &&
                                                    mutationResult.data.updateSetting.setting.value
                                            );
                                            if (savedTimeoutRef.current) {
                                                clearTimeout(savedTimeoutRef.current);
                                            }
                                            // @ts-expect-error
                                            savedTimeoutRef.current = setTimeout(() => {
                                                setValueSaved(null);
                                            }, 1000);
                                        })
                                        .catch((errMsg) => {
                                            props.onError(errMsg);
                                        });
                                }}
                            />
                        </SavedSettingToast>
                    );
                }

                return null;
            }}
        </Setting>
    );
}
